import React, { createContext, useContext, useEffect, useState } from 'react';

type LanguageKey = 'en' | 'de' | 'ta' | 'fr' | 'hi' | 'es' | 'ar' | 'ru' | 'zh' | 'si' | 'tr';

type LanguageContextType = {
  language: LanguageKey;
  setLanguage: (lang: LanguageKey) => void;
}; 

const LanguageContext = createContext<LanguageContextType>({
  language: 'en',
  setLanguage: () => {},
});

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguageState] = useState<LanguageKey>('en');

  const setLanguage = (lang: LanguageKey) => {
    setLanguageState(lang);
    localStorage.setItem('selectedLanguage', lang);
  };

  useEffect(() => {
    const loadLanguage = () => {
      const storedLang = localStorage.getItem('selectedLanguage');
      if (storedLang && isLanguageKey(storedLang)) {
        setLanguageState(storedLang);
      }
    };

    loadLanguage();
  }, []);

  const isLanguageKey = (key: string): key is LanguageKey => {
    return ['en', 'de', 'ta', 'fr', 'hi', 'es', 'ar', 'ru', 'zh', 'si', 'tr'].includes(key);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
